import React from 'react';
import { FieldError } from 'react-hook-form';
import './style.scss';

export type CheckboxProps = {
  children?: React.ReactNode;
  title?: string;
  checked?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: () => void;
  errors?: FieldError; // react-hook-form
};

const Checkbox = (props: CheckboxProps) => {
  return (
    <span className="checkbox-wrapper">
      <input
        className="checkbox"
        type="checkbox"
        checked={props.checked}
        disabled={props.disabled}
        readOnly={props.readOnly}
        onChange={props.onChange}
      />
      {props.children}
      {props.title ? (
        <label className="checkbox-label" onClick={props.onChange}>
          {props.title}
        </label>
      ) : null}
    </span>
  );
};
export default Checkbox;
